"use client";

import { useCallback, useEffect, useState } from "react";

/** care_link_worker 向け。care_link_worker_mobile では使用しない */
export const PRIVACY_POLICY_REVISION_NOTICE_MODAL_STORAGE_KEY =
  "privacyPolicyRevisionNoticeModalHidden";

export function usePrivacyPolicyRevisionNoticeModal() {
  const [shouldHide, setShouldHide] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(
        PRIVACY_POLICY_REVISION_NOTICE_MODAL_STORAGE_KEY,
      );

      if (stored === "true") {
        setShouldHide(true);
      } else {
        setShouldHide(false);
      }
    } catch (error) {
      console.warn("Failed to read from localStorage:", error);
      setShouldHide(false);
    } finally {
      setIsLoaded(true);
    }
  }, []);

  const setHideModal = useCallback((hide: boolean) => {
    try {
      if (hide) {
        localStorage.setItem(
          PRIVACY_POLICY_REVISION_NOTICE_MODAL_STORAGE_KEY,
          "true",
        );
      } else {
        localStorage.removeItem(
          PRIVACY_POLICY_REVISION_NOTICE_MODAL_STORAGE_KEY,
        );
      }
      setShouldHide(hide);
    } catch (error) {
      console.warn("Failed to write to localStorage:", error);
    }
  }, []);

  const shouldShowModal = useCallback(() => {
    if (!isLoaded) return false;
    if (shouldHide) return false;

    return true;
  }, [shouldHide, isLoaded]);

  return {
    shouldShowModal,
    setHideModal,
    isLoaded,
  };
}
